export default __webpack_public_path__ + "static/media/rendingstrikes.1450201f.png";